import { render, staticRenderFns } from "./widget-editor-floating-preview-control.vue?vue&type=template&id=f130a8dc&scoped=true&"
import script from "./widget-editor-floating-preview-control.vue?vue&type=script&lang=js&"
export * from "./widget-editor-floating-preview-control.vue?vue&type=script&lang=js&"
import style0 from "./widget-editor-floating-preview-control.vue?vue&type=style&index=0&id=f130a8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130a8dc",
  null
  
)

export default component.exports